import buildRfdc from 'rfdc';

const rfdc = buildRfdc();

export const deepCopy = <O = any>(obj: O): O => rfdc(obj);
